import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import cryptoMd5 from 'crypto-js/md5';
import { SettingUserEntity } from '../models';
import { Session } from '../interfaces';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { UserExternalDTO, UserExternalFilterDTO } from '../models/configuration-system/user-external.model';

@Injectable({
  providedIn: 'root'
})
export class ManagementUserService extends AuthService {
  session: Session = JSON.parse(
    localStorage.getItem(environment.sessionAuth)
  );
  /** List all users */
  getUserEntity(limit, offset): Observable<SettingUserEntity[]> {
    return this.apiService.get(`${this.apiService.userEntity}?limit=${limit}&offset=${offset}`).pipe();
  }
  /**Search user */
  getUsersPredictiva(value): Observable<SettingUserEntity[]> {
    return this.apiService.get(`${this.apiService.userEntity}/search?username=${value}`).pipe(map(response => {
        const str: string[] = response.map(i => JSON.stringify(i));
        const l = Array.from(new Set(str));
        const b = l.map(m => JSON.parse(m));
        return b;
    }));
  }
  /** Cargar un usuario */
  findUserByUsername(id): Observable<SettingUserEntity> {
    return this.apiService.get(`${this.apiService.userEntity}/search?username=${id}`).pipe(map(item => item[0]));
  }
  /**evaluar si se utiliza */
  /* generateRelation(data): Observable<SettingUserEntity> {
    return this.apiService.put(`${this.apiService.userEntity}/${data.userId}`, data.user).pipe();
  } */
  /** Crea un usuario */
  createAndUpdateUser(data): Observable<SettingUserEntity> {
    return this.apiService.post(`${this.apiService.userEntity}`, data.user).pipe();
  }
  /** lista de permisos */
  getPermisses(): Observable<any> {

    if (this.session && this.session.permises) {
      return of(this.session.permises);
    } else {
      return this.apiService.get(`${this.apiService.userEntity}/permissions`)
        .pipe(map(response => {
          this.session.permises = response;
          localStorage.setItem(
            environment.sessionAuth,
            JSON.stringify(this.session)
          );
          return response;
        }
        ));
    }

  }
  /** Lista de roles */
  getRoles(): Observable<any> {
    if (this.session && this.session.roles) {
      return of(this.session.roles);
    } else {
      return this.apiService.get(`${this.apiService.userEntity}/roles`)
      .pipe(map(response => {
        this.session.roles = response;
        localStorage.setItem(
          environment.sessionAuth,
          JSON.stringify(this.session)
        );
        return response;
      }))
    }
  }

  preparePassword(username: string, password: string): string {
    const companyCode = this.getUser().entity.company.code;
   const template = `${username}:${password}:${companyCode}`;
    return cryptoMd5(template).toString();
}

    /** List all users external por filtro */
  getUserExternalFilter(userExternalFilterDTO : UserExternalFilterDTO,limit, offset): Observable<UserExternalDTO[]> {
    return this.apiService.post(`${this.apiService.apiAuth}/user-external/search-filter?limit=${limit}&offset=${offset}`, userExternalFilterDTO).pipe();
  }
  
  /** List all users external */
  getAllUserExternal(limit, offset, active): Observable<UserExternalDTO[]> {
    return this.apiService.get(`${this.apiService.apiAuth}/user-external?limit=${limit}&offset=${offset}&active=${active}`).pipe();
  }

  /** Cargar un usuario externo */
  getUserExternalById(id : number): Observable<UserExternalDTO> {
    return this.apiService.get(`${this.apiService.apiAuth}/user-external/${id}`);
  }

    /** Guarda / Actualiza un usuario */
  createOrUpdateUserExxternal(user : UserExternalDTO): Observable<UserExternalDTO> {
      return this.apiService.post(`${this.apiService.apiAuth}/user-external`, user);
  }

  deactivateExternalUsers(deactivateExternalUsersRequest: { users: UserExternalDTO[] }): Observable<any> {
    return this.apiService.post(
      `${this.apiService.apiAuth}/user-external/delete`,
      deactivateExternalUsersRequest,
      { responseType: 'text' }
    );
  }
}
